import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=06618939"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports